import React from 'react';
import './Clientes-Modal.css';

import Video from './assets/Capilla_San_Pedro/Video.mp4';

const Capilla = () => {
    return (
        <div className='container'>
            <h2> 
                ✅ Proyecto: Capilla Nuestra Señora de Guadalupe🌞✨
            </h2>
            <video controls>
                <source src={Video} type="video/mp4" />
                Tu navegador no soporta la reproducción de video.
            </video>
            <p>
               

<span className="highlight"> Fe y sostenibilidad caminando de la mano: esta capilla ahora honra su misión espiritual mientras cuida la creación.</span><br/><br/>

En este lugar instalamos un sistema solar fotovoltaico conectado a la red con una capacidad de 1.38 kWp, conformado por 4 paneles solares de alta eficiencia y un microinversor de 1.6 kW, una tecnología que optimiza el rendimiento energético, permite el monitoreo individual por panel y garantiza un funcionamiento seguro y estable.<br/>

<br/> Los objetivos de este proyecto fueron:<br/><br/>

✔ Reducir los costos asociados al consumo eléctrico de la capilla.<br/>
✔ Implementar una solución sostenible, alineada con el cuidado del medio ambiente.<br/>
✔ Garantizar energía continua para iluminación y equipos de uso frecuente.<br/><br/>

Hoy, la capilla <span className="highlight">"Nuestra señora de Guadalupe"</span> genera su propia energía limpia, disminuyendo los costos mensuales de electricidad y liberando recursos que pueden ser destinados a otras necesidades de la comunidad.
Además, esta instalación contribuye activamente a la reducción de emisiones de CO₂, convirtiendo este espacio de fe en un ejemplo de responsabilidad ambiental.<br/>

<span className="highlight"><br/>Este proyecto cuenta con el acompañamiento de IPSUM Ingeniería e Innovación, ofreciendo:<br/><br/></span>

🔧 Soporte técnico y mantenimiento preventivo.<br/>
🔧 Monitoreo del sistema para garantizar máxima eficiencia.<br/>
🔧 Instalación estructural segura y diseñada para facilitar futuros mantenimientos.<br/>
🔧 Capacitación al usuario en el manejo de la aplicación de monitoreo.<br/>
🔧Acompañamiento presencial de nuestros ingenieros durante y después de la instalación.<br/>

<span className="highlight"><br/><br/>Una decisión inteligente que une ahorro, sostenibilidad y propósito en la fé.</span>
            </p>
        </div>
    );
}

export default Capilla;
